import { PropsWithChildren } from "react";
import cls from "./Frame.module.css";

export type FrameProps = PropsWithChildren & {

}

export default function Frame(props: FrameProps) {
    return (
        <div className={cls.frame}>
            {props.children}
        </div>
    )
}